import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import { Box, TableBody, Typography } from '@mui/material';
import emptyBox from '../asset/boxBlank.png';
import palette from 'src/theme/palette';

// ----------------------------------------------------------------------

export function TableNoData({ colSpan, sx, title }) {
  return (
    <TableBody>
      <TableRow>
        <TableCell align="center" colSpan={colSpan} sx={{ py: 10, ...sx }}>
          <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
            <img src={emptyBox} style={{ width: '120px' }} />

            <Typography
              sx={{ fontSize: 14, fontFamily: 'poppinsBold', color: palette.primary.main }}
            >
              {title ? title : 'No Data Found!'}
            </Typography>
          </Box>
        </TableCell>
      </TableRow>
    </TableBody>
  );
}
